<template>
    <div class="feedback-component">
        <van-dialog v-model="show" theme="round" :showConfirmButton="false" :showCancelButton="false">
            <template #default>
                <div>
                    <div class="title"><span>请选择反馈内容</span><i class="ico ico-icon_02" @click="close(false)"></i></div>
                    <div class="checkbox-group">
                        <div class="checkbox" v-for="item of options" :key="item.key">
                            <i :class="['ico', checked.includes(item.key) ? 'ico-icon_101' : 'ico-icon_100']" @click="check(item.key)"></i>
                            <span>{{item.text}}</span>
                        </div>
                    </div>
                    <div class="reason" v-show="showReason">
                        <textarea placeholder="限50字内" v-model="reason"></textarea>
                    </div>
                    <div class="btn-group">
                        <div class="btn" @click="close(false)">取消</div>
                        <div class="btn submit" @click="close(true)">提交</div>
                    </div>
                </div>
            </template>
        </van-dialog>
    </div>
</template>
<script>
import { Dialog } from 'vant'
import { throttle } from 'lodash'
import { doFeedback } from '@/models/custom'
export default {
    name: 'feedback',
    components: {
        [Dialog.name]: Dialog
    },
    props: {
        params: {
            type: Object,
            default: () => {}
        }
    },
    data () {
        return {
            show: false,
            options: [
                {key: 1, text: '根据地理位置，返回最近的门店不正确'},
                {key: 2, text: '页面内容缺失或包含不常规内容'},
                {key: 3, text: '访问速度过慢'},
                {key: 0, text: '其他'},
            ],
            checked: [],
            reason: '',
            showReason: false
        }
    },
    watch: {
        reason: throttle(function (newValue) {
            this.reason = newValue.slice(0, 50)
        }, 100)
    },
    methods: {
        close (flag) {
            if (flag) {
                if (this.checked.length) {
                    if (this.checked.includes(0) && !this.reason) {
                        this.$toast('请输入原因')
                    } else {
                        doFeedback(Object.assign({
                            link: location.href,
                            status: this.checked.join(','),
                            reason: this.reason}, this.params))
                        this.show = false
                    }
                } else {
                    this.$toast('请选择选项')
                }
            } else {
                this.show = false
            }
        },
        check (key) {
            if (this.checked.some(item => item === key)) {
                this.checked = this.checked.filter(item => item !== key)
                if (key === 0) {
                    this.showReason = false
                }
            } else {
                if (key === 0) {
                    this.showReason = true
                }
                this.checked.push(key)
            }
        }
    }
}
</script>
<style lang="stylus">
    .feedback-component
        .van-dialog
            border-radius 16px !important
            .van-dialog__content
                .title
                    display flex
                    justify-content space-between
                    align-items center
                    padding  0 30px
                    height 88px
                    background-color $bgGreyColor
                    span
                        display inline-block
                        position relative
                        font-size $font34
                        color $inputTextColor
                        &:after
                            content ''
                            position absolute
                            bottom -5px
                            right 0
                            width 100%
                            height 12px
                            background-image: linear-gradient(90deg,
                                #ff6600 0%,
                                #fc2d2d 100%),
                            linear-gradient(
                                #fc2d2d,
                                #fc2d2d)
                            background-blend-mode normal,
                                normal
                            border-radius 6px
                            opacity 0.3
                .checkbox-group
                    padding  55px 60px 40px
                    .checkbox
                        display flex
                        align-items center
                        color $fcGrey
                        font-size $fontlessBase
                        &:not(:first-child)
                            padding-top 36px
                        span
                            padding-left 12px
                .reason
                    padding 0 30px
                    textarea
                        box-sizing border-box
                        width 100%
                        height 140px
                        border 0
                        resize none
                        background-color #f3f3f3
                        border-radius 10px
                        border solid 1px #e5e5e5
                        padding 20px 27px
                        font-size $fontBase
                        -webkit-appearance none
                        -webkit-user-select auto
                        // color $fcGreyish
                .btn-group
                    display flex
                    justify-content space-between
                    padding 36px 50px
                    .btn
                        width 230px
                        height 88px
                        line-height 88px
                        text-align center
                        border-radius 44px
                        background-color #f3f3f3
                        color #666666
                        &.submit
                            color $fcWhite
                            background-image: linear-gradient(90deg,
                            #ff5442 0%,
                            #fc2d2d 100%),
                        linear-gradient(
                            #f3f3f3,
                            #f3f3f3)
                        background-blend-mode: normal,
                            normal

</style>
